import React from "react";
import { TV_PLATFORMS } from "../mock";
import BrandIcon from "./BrandIcon";

function formatUsers(str) {
  const m = str.match(/^([\d.]+)([MB])/);
  if (!m) return str.replace(' Users', '');
  return `${m[1]} ${m[2] === 'B' ? 'Billion' : 'Million'}`;
}

const ALL_PLATFORMS = TV_PLATFORMS;

// Each cell: icon on dark bg, stat on gold bg — always matched
function PlatformCell({ platform }) {
  return (
    <div className="flex flex-col">
      {/* Icon */}
      <div className="bg-[#080a10] flex items-center justify-center py-5 sm:py-6 md:py-8 px-2 flex-1">
        <BrandIcon
          slug={platform.slug}
          customIcon={platform.customIcon}
          color={platform.color}
          iconColor={platform.iconColor}
          name={platform.name}
          size={52}
        />
      </div>
      {/* Stat */}
      <div
        className="text-center py-3 sm:py-4 md:py-5 px-1"
        style={{ background: "linear-gradient(180deg, #fce181 0%, #f5c451 50%, #d6a836 100%)" }}
      >
        <div className="font-display text-[10px] sm:text-xs md:text-sm lg:text-xl text-[#1a0f00] leading-tight">
          {formatUsers(platform.users)}
        </div>
        <div className="text-[6px] sm:text-[7px] md:text-[9px] tracking-[0.16em] uppercase text-[#1a0f00]/80 font-semibold mt-0.5 sm:mt-1">
          Viewers
        </div>
      </div>
    </div>
  );
}

function PlatformRow({ platforms }) {
  const count = platforms.length;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7">
      {platforms.map((p, i) => {
        // On mobile (2-col): if total is odd and this is the last item, span 2 cols to fill
        const isLastOdd = count % 2 !== 0 && i === count - 1;
        return (
          <div
            key={p.name}
            className={`bg-transparent${
              isLastOdd ? " col-span-2 sm:col-span-1" : ""
            }`}
          >
            <PlatformCell platform={p} />
          </div>
        );
      })}
    </div>
  );
}

export default function WhereSeen() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-8 overflow-hidden">
      <div className="relative max-w-7xl mx-auto text-center">
        <div className="text-[#14b8a6] text-xs md:text-sm font-semibold tracking-[0.3em] uppercase mb-4">
          Motivation &amp; Success Network
        </div>
        <h2 className="font-display text-4xl md:text-5xl lg:text-7xl leading-[0.95] text-white">
          WHERE YOU&apos;LL BE <span className="text-teal-bold">SEEN</span>-
        </h2>
        <p className="mx-auto mt-7 text-white/65 max-w-2xl leading-relaxed text-base md:text-lg">
          Your annuity producer feature streams across 14+ major smart TV and mobile platforms, reaching billions of potential clients worldwide. Free of charge.
        </p>

        {/* Showcase: unified grid — icon + stat always paired per column */}
        <div className="mt-12 rounded-md border border-white/10 bg-[#080a10] overflow-hidden flex flex-col">
          <PlatformRow platforms={ALL_PLATFORMS} />
        </div>
      </div>
    </section>
  );
}
